import React from 'react';

import { AuthenticatedRoute } from '@/console/app/protected-route/authenticated-route';
import { PermissionRoute } from '@/console/app/protected-route/permission-route';

export const ProtectedRoute = ({ children }: { children: React.ReactNode }) => {
  return (
    <AuthenticatedRoute>
      <PermissionRoute>{children}</PermissionRoute>
    </AuthenticatedRoute>
  );
};
